import { Routes } from '@angular/router';
import { provideState } from '@ngrx/store';

import * as fromStore from './store';
import { provideEffects } from '@ngrx/effects';
import { NewsDetailComponent } from './containers/news-detail/news-detail.component';
import { NewsDetailGuard } from './guards/news-detail.guard';
import { NewsDetailMetaGuard } from './guards/news-detail-meta.guard';
import { NewsOverviewComponent } from './containers/news-overview/news-overview.component';
import { NewsOverviewGuard } from './guards/news-overview.guard';
import { FeaturedNewsGuard } from './guards/featured-news.guard';
import { resetMenuThemeGuard } from '../guards/menu-theme.guard';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: NewsOverviewComponent,
        canActivate: [NewsOverviewGuard, FeaturedNewsGuard],
      },
      {
        path: ':newsId/:target',
        component: NewsDetailComponent,
        canActivate: [NewsDetailGuard, NewsDetailMetaGuard],
      },
    ],

    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
